var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepper2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.906,
    height: 212.359,
    viewBox: "0 0 226.906 212.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6319",
    "data-name": "Group 6319",
    transform: "translate(-977.047 -171.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5706",
    "data-name": "Group 5706",
    transform: "translate(1072.008 345.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5372",
    "data-name": "Rectangle 5372",
    width: 47.48,
    height: 5.715,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M58.562,140.549a17.585,17.585,0,0,0-17.305,14.64h-.264a29.281,29.281,0,1,1,0-58.562h3.192a17.548,17.548,0,0,0,34.61,0H108.6a17.548,17.548,0,0,0,34.61,0h3.192a35.137,35.137,0,1,0,0-70.274H122.717a17.548,17.548,0,0,0-34.61,0H64.419V2.928A2.927,2.927,0,0,0,61.49,0H2.928A2.927,2.927,0,0,0,0,2.928v46.85a2.927,2.927,0,0,0,2.928,2.928H61.49a2.927,2.927,0,0,0,2.928-2.928V32.209H88.107a17.548,17.548,0,0,0,34.61,0h23.688a29.281,29.281,0,1,1,0,58.562h-3.192a17.548,17.548,0,0,0-34.61,0H78.8a17.548,17.548,0,0,0-34.61,0H40.994a35.137,35.137,0,1,0,0,70.274h.264a17.548,17.548,0,0,0,34.61,0h6.12v-5.856h-6.12A17.585,17.585,0,0,0,58.562,140.549ZM29.281,5.856h5.856V17.569H29.281ZM58.562,46.85H5.856V5.856H23.425V20.5a2.927,2.927,0,0,0,2.928,2.928H38.065A2.927,2.927,0,0,0,40.994,20.5V5.856H58.562Zm46.85-5.856a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,105.412,40.993Zm20.5,40.993A11.712,11.712,0,1,1,114.2,93.7,11.724,11.724,0,0,1,125.909,81.987Zm-64.419,0A11.712,11.712,0,1,1,49.778,93.7,11.724,11.724,0,0,1,61.49,81.987ZM58.562,169.83a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,58.562,169.83Z",
    transform: "translate(991.555 190.378)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_tick_3923816",
    transform: "translate(1167.953 285.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M19.5,2A17.5,17.5,0,1,0,37,19.5,17.5,17.5,0,0,0,19.5,2Zm9.933,14.415-10.5,9.625a1.75,1.75,0,0,1-2.42-.052l-5.25-5.25a1.75,1.75,0,1,1,2.475-2.475L17.8,22.328l9.265-8.493a1.75,1.75,0,0,1,2.366,2.58Z",
    transform: "translate(-1 8)",
    fill: "#f37320"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M11237.627,20190.123l-31.055,25.463v39.717h62.706v-38.818Z",
    transform: "translate(-10087.084 -19873.922)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M0,0,24.72,17.673",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 1139.543, 313.564)",
    fill: "none",
    stroke: "#f37320",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6318",
    "data-name": "Group 6318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 80.453,
    height: 72.539,
    transform: "translate(977.047 179.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316",
    transform: "translate(637.874 -56.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M13048.237,3006.189v-39.4h-54.087v63.532h54.087v-9.884",
    transform: "translate(-12630.999 -2737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M13006.959,2984.087h37.992",
    transform: "translate(-12636.092 -2743.879)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M13006.959,2984.087h37.992",
    transform: "translate(-12636.092 -2735.446)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M13006.959,2984.087h17.918",
    transform: "translate(-12636.092 -2725.205)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M13006.959,2984.087h17.918",
    transform: "translate(-12636.092 -2716.772)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M13006.959,2984.087h17.918",
    transform: "translate(-12636.092 -2708.338)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M13006.959,2984.087h17.918",
    transform: "translate(-12636.092 -2699.905)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M13047.6,3021.286l6.383-5.882,6.9,5.882",
    transform: "translate(-12652.252 -2756.332)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M13058.121,3015.4v24.1",
    transform: "translate(-12656.435 -2756.332)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper2);
export default __webpack_public_path__ + "static/media/stepper2.14f0a1305b87cf5f20df654ed561d790.svg";
export { ForwardRef as ReactComponent };